import { STUDENT_MANAGEMENT } from '../../api/endpoints';
import request from '../../api/request';
import { BaseResponse } from './types';

export function getBase() {
  return request<BaseResponse>(STUDENT_MANAGEMENT.STUDY_PLAN_INFORMATION, {
    method: 'GET',
  });
}
